"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CommentsFieldDirective = /** @class */ (function () {
    function CommentsFieldDirective() {
        return {
            restrict: 'EA',
            scope: true,
            bindToController: {
                comment: '=',
                label: '=',
                placeholder: '='
            },
            templateUrl: '/Partner/TaskComponents/CommentsField',
            controllerAs: 'commentsField',
            controller: function () {
            }
        };
    }
    CommentsFieldDirective.create = function () {
        return new CommentsFieldDirective();
    };
    return CommentsFieldDirective;
}());
exports.CommentsFieldDirective = CommentsFieldDirective;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbWVudHNGaWVsZC5kaXJlY3RpdmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb21tZW50c0ZpZWxkLmRpcmVjdGl2ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBO0lBQ0k7UUFDSSxPQUFPO1lBQ0gsUUFBUSxFQUFFLElBQUk7WUFDZCxLQUFLLEVBQUUsSUFBSTtZQUNYLGdCQUFnQixFQUFFO2dCQUNkLE9BQU8sRUFBRSxHQUFHO2dCQUNaLEtBQUssRUFBRSxHQUFHO2dCQUNWLFdBQVcsRUFBRSxHQUFHO2FBQ25CO1lBQ0QsV0FBVyxFQUFFLHVDQUF1QztZQUNwRCxZQUFZLEVBQUUsZUFBZTtZQUM3QixVQUFVLEVBQUU7WUFDWixDQUFDO1NBQ0osQ0FBQTtJQUNMLENBQUM7SUFFTSw2QkFBTSxHQUFiO1FBQ0ksT0FBTyxJQUFJLHNCQUFzQixFQUFFLENBQUM7SUFDeEMsQ0FBQztJQUVMLDZCQUFDO0FBQUQsQ0FBQyxBQXJCRCxJQXFCQztBQXJCWSx3REFBc0IifQ==